import audio from '@/assets/images/common/audio.png';
import sms from '@/assets/images/common/sms.png';
import sourceFile from '@/assets/images/common/sourceFile.png';
import txt from '@/assets/images/common/txt.png';
import video from '@/assets/images/common/video.png';
import other from '@/assets/images/common/other.png';
import image from '@/assets/images/common/image.png';

export const srcType = {
    '1': { typ: '图片', src: image },
    '2': { typ: '音频', src: audio },
    '3': { typ: '视频', src: video },
    '4': { typ: '文本', src: txt },
    '5': { typ: '源文件', src: sourceFile },
    '6': { typ: '其它', src: other },
    '7': { typ: '短信', src: sms },
}

export const srcSuffix = [
    { num: '1', suffix: "jpg/jepg/bmp/gif/png", typ: '图片' },
    { num: '2', suffix: "mp3/wav", typ: '音频' },
    { num: '3', suffix: "mp4", typ: '视频' },
    { num: '4', suffix: "", typ: '文本' },
    { num: '5', suffix: "PSD/AI/C4D", typ: '源文件' },
    { num: '6', suffix: "*", typ: '其它' },
    { num: '7', suffix: "", typ: '短信' }
]
